// @flow

import Loader from './loader';
import StyledLoader from './loader.styled';

export { StyledLoader };

export default Loader;
